// extracted by mini-css-extract-plugin
export default {"reasonCategoryGroup":"d5aGkSEfKTFpqQRx9Pwf","reasonItem":"UmjkdOExg50ru3EWc5M9"};